export const LIVE_API_BASE_URL = (process.env.REACT_APP_API_URL ||
  'https://stunning-saga-477016-k5.et.r.appspot.com/api').replace(/\/+$/, '');

if (process.env.NODE_ENV === 'production' && !LIVE_API_BASE_URL.startsWith('https://')) {
  throw new Error('Production requires an HTTPS API URL.');
}

// Only the local development server proxies requests. Shipped builds use HTTPS directly.
export const API_BASE_URL = process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_USE_DEV_PROXY === 'true'
  ? new URL(LIVE_API_BASE_URL).pathname
  : LIVE_API_BASE_URL;
